import React from "react";
import GetVatTypeName from "../../functions/utils/getVatTypeName";
import moneyFormat from "../../functions/utils/moneyFormat";
import { Divider } from "antd";

const InvoiceDescription = ({ data }) => {
  const hasVat = data.invoiceItems.find((item) => item.invoiceItemVatInfo);
  const vatInfo = hasVat ? hasVat.invoiceItemVatInfo : null;

  return (
    <div className="w-full bg-gray-600 shadow-md rounded-2xl p-6 mb-4 space-y-4">
      <div className="flex flex-col md:flex-row justify-between items-center md:items-center gap-4">
        <span className="text-lg font-medium text-center text-white">
          {data.description}
        </span>
      </div>

      {hasVat && (
        <div className="bg-gray-400 border border-gray-200 rounded-lg p-4 space-y-2">
          <div className="flex justify-between items-center text-sm">
            <span className="font-medium text-gray-600">НӨАТ-ын баримт</span>
            <span className="text-gray-500">
              {GetVatTypeName(vatInfo.type)}
            </span>
          </div>
          {vatInfo.easyRegister && (
            <div className="flex justify-between items-center text-sm">
              <span className="text-gray-600">НӨАТ-ын хялбар бүртгэл</span>
              <span className="text-gray-600">{vatInfo.easyRegister}</span>
            </div>
          )}
        </div>
      )}
      <Divider className="bg-gray-200" />
      <div className="flex flex-row justify-between items-center">
        <div>
          <span className="text-gray-200"> Төлөх дүн</span>
        </div>
        <div>
          <span className="text-xl font-bold text-white">
            {moneyFormat(data.amount)}₮
          </span>
        </div>
      </div>
      <div
        className="w-full flex justify-end text-[12px] text-gray-300"
        style={{ marginTop: 0 }}
      >
        <div className="flex gap-2">
          <span>шимтгэл:</span>
          <span>{parseInt(data.feeAmount)}₮</span>
        </div>
      </div>
    </div>
  );
};

export default InvoiceDescription;
